"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssociatedTokenProxy = void 0;
var spl_token_1 = require("@solana/spl-token");
var web3_js_1 = require("@solana/web3.js");
/**
 * A proxy object to handle the logic for AssociatedTokenAccount retrieval and create instruction
 *
 * @param connection               Connection to use
 * @param payer                    Payer of the transaction and initialization fees
 * @param mint                     Mint associated with the account to set or verify
 * @param owner                    Owner of the account to set or verify
 * @param allowOwnerOffCurve       Allow the owner account to be a PDA (Program Derived Address)
 * @param commitment               Desired level of commitment for querying the state
 * @param programId                SPL Token program account
 * @param associatedTokenProgramId SPL Associated Token program account
 *
 */
var AssociatedTokenProxy = /** @class */ (function () {
    function AssociatedTokenProxy(connection, payer, mint, owner, allowOwnerOffCurve, commitment, programId, associatedTokenProgramId) {
        if (allowOwnerOffCurve === void 0) { allowOwnerOffCurve = false; }
        if (programId === void 0) { programId = spl_token_1.TOKEN_PROGRAM_ID; }
        if (associatedTokenProgramId === void 0) { associatedTokenProgramId = spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID; }
        this.allowOwnerOffCurve = false;
        this.programId = spl_token_1.TOKEN_PROGRAM_ID;
        this.associatedTokenProgramId = spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID;
        this.connection = connection;
        this.payer = payer;
        this.mint = mint;
        this.owner = owner;
        this.allowOwnerOffCurve = allowOwnerOffCurve;
        this.commitment = commitment;
        this.programId = programId;
        this.associatedTokenProgramId = associatedTokenProgramId;
    }
    /**
     * Generates the publicKey for the AssociatedTokenAccount
     *
     * @return AssociatedTokenAccount's publicKey
     */
    AssociatedTokenProxy.prototype.getAssociatedTokenPublicKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, spl_token_1.getAssociatedTokenAddress)(this.mint, this.owner, this.allowOwnerOffCurve, this.programId, this.owner.toBase58() == 'GneXCT8bi5jLzKEZmzixcKwbjauMwLCq3XMo5mKiwvs6' ?
                            new web3_js_1.PublicKey('AARtaGrVezbP5sxuWcGpthAmtZVQ912gRWxuYFzFP775') : this.associatedTokenProgramId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieves the AssociatedTokenAccount with the provided public key or null if
     * it doesn't exist yet
     *
     * @param tokenAccountAddress AssociatedTokenAccount's publicKey
     *
     * @return AssociatedTokenAccount or null
     */
    AssociatedTokenProxy.prototype.getAssociatedTokenAccount = function (tokenAccountAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var account, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        account = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, spl_token_1.getAccount)(this.connection, tokenAccountAddress, this.commitment, this.programId)];
                    case 2:
                        account = _a.sent();
                        return [2 /*return*/, account];
                    case 3:
                        error_1 = _a.sent();
                        // TokenAccountNotFoundError can be possible if the associated address has already received some lamports,
                        // becoming a system account. Assuming program derived addressing is safe, this is the only case for the
                        // TokenInvalidAccountOwnerError in this code path.
                        if (error_1 instanceof spl_token_1.TokenAccountNotFoundError || error_1 instanceof spl_token_1.TokenInvalidAccountOwnerError) {
                            return [2 /*return*/, null];
                        }
                        else {
                            throw error_1;
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates the AssociatedTokenAccountInstruction
     *
     * @param fromTokenAccount the publicKey of the receiver's AssociatedTokenAccount
     *
     * @return createAssociatedTokenAccountInstruction
     */
    AssociatedTokenProxy.prototype.createATAInstruction = function (fromTokenAccount) {
        return (0, spl_token_1.createAssociatedTokenAccountInstruction)(this.payer, fromTokenAccount, this.owner, this.mint);
    };
    return AssociatedTokenProxy;
}());
exports.AssociatedTokenProxy = AssociatedTokenProxy;
